import _ from 'lodash';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { NavDropdown, FormGroup, FormControl, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Switch from 'react-switch';
import ChatControls from './ChatControls';
import ChatUsers from './ChatUsers';
import OnlineStatus from '../chat/OnlineStatus';
import Socket from '../../services/SocketService';
import Api from '../../services/ApiService';
import { getUser } from '../../actions/AppActions';
import { showRoom, getUsers, setOnlineStatus } from '../../actions/ChatActions';

class NavChat extends PureComponent {
  constructor(props) {
    super(props);

    this.handleStatusChange = this.handleStatusChange.bind(this);
    this.toggleSettings = this.toggleSettings.bind(this);
    this.toggleNotifications = this.toggleNotifications.bind(this);

    this.state = {
      settings: false,
    };
  }

  componentDidMount() {
    // TODO Could be more efficient
    Socket.global
      .on('user.login', this.props.getUsers)
      .on('user.logout', userId => {
        this.props.setOnlineStatus(userId, 'Offline');
      })
      .on('user.status', payload => {
        this.props.setOnlineStatus(payload.userId, payload.status);
      });
    this.props.getUsers();
  }

  componentWillUnmount() {
    Socket.global.off('user.login').off('user.logout');
  }

  handleStatusChange(event) {
    Api.post('chat/status', { status: event.target.value }).then(response => {
      this.props.setOnlineStatus(response.data.userId, response.data.status);
    });
  }

  myStatus() {
    const { me } = this.props;

    // Auto-logout likely happened
    if (!me || !me.status) {
      return 'Offline';
    }

    return me.status;
  }

  toggleSettings() {
    this.setState(prevState => {
      return { settings: !prevState.settings };
    });
  }

  toggleNotifications(status) {
    if (status) {
      Notification.requestPermission().then(result => {
        if (result === 'granted') {
          Api.put('user/data', { key: 'notifications', data: true }).then(() => {
            this.props.getUser();
          });
        }
      });
    } else {
      Api.put('user/data', { key: 'notifications', data: false }).then(() => {
        this.props.getUser();
      });
    }

    this.setState(prevState => {
      return { notifications: !prevState.notifications };
    });
  }

  renderTitle() {
    const status = this.myStatus();

    return (
      <div className="navbar-item-title">
        {status !== 'Offline' && <OnlineStatus status={status} />}
        <i className="zmdi zmdi-comments zmdi-hc-2x" />
      </div>
    );
  }

  renderControls() {
    const status = this.myStatus();
    // TODO if the result if myStatus changes outside of these controls, the
    // current selection will be incorrect.
    return (
      <ChatControls>
        <div className="chat-status">
          <OnlineStatus status={status} />
          <FormGroup controlId="formControlsSelect" className="form-select">
            <FormControl
              as="select"
              placeholder="select"
              value={this.myStatus()}
              onChange={this.handleStatusChange}
            >
              <option value="Available">Available</option>
              <option value="Busy">Busy</option>
              <option value="Offline">Offline</option>
            </FormControl>
          </FormGroup>
        </div>
        <div className="chat-toolbar" onClick={this.toggleSettings}>
          <i className="zmdi zmdi-settings" />
        </div>
      </ChatControls>
    );
  }

  render() {
    const { users, me, notifications } = this.props;

    const controls = users.length ? this.renderControls() : null;
    const userList =
      users.length && this.myStatus() !== 'Offline' ? (
        <ChatUsers open={this.props.showRoom} users={users} me={me} />
      ) : null;

    return (
      <NavDropdown id="chat-dropdown" title={this.renderTitle()} className="top-level-menu no-caret d-none d-sm-block" alignRight>
        {controls}
        {userList}
        {this.state.settings && (
          <div className="chat-settings">
            <div className="setting-name">Enable Notifications</div>
            <div className="setting-control">
              <Switch
                onChange={this.toggleNotifications}
                checked={notifications}
                onColor="#86d3ff"
                onHandleColor="#2693e6"
                handleDiameter={17}
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                height={12}
                width={27}
              />
            </div>
            <div className="close-button">
              <Button size="sm" onClick={this.toggleSettings} variant="secondary">
                Done
              </Button>
            </div>
          </div>
        )}
      </NavDropdown>
    );
  }
}

NavChat.defaultProps = {
  notifications: false,
};

NavChat.propTypes = {
  getUser: PropTypes.func,
  getUsers: PropTypes.func,
  me: PropTypes.object,
  notifications: PropTypes.bool,
  setOnlineStatus: PropTypes.func,
  showRoom: PropTypes.func,
  users: PropTypes.array,
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ showRoom, getUsers, setOnlineStatus, getUser }, dispatch);
}

function mapStateToProps(state) {
  return {
    notifications: _.get(state, 'app.user.data.notifications'),
    me: state.chat.me,
    users: state.chat.users,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NavChat);
